















import { Component, Vue } from 'vue-property-decorator';
import cart from '@/store/modules/cart';
import checkout from '@/store/modules/checkout';
import { ShippingTimes } from '@/store/models';

@Component({
    components: {},
})
export default class TotalsComp extends Vue {
    get loading(): boolean {
        return cart.loadingFlags.totals;
    }

    get shippingMethodTimes(): ShippingTimes {
        return checkout.selectedShippingMethodTimes;
    }

    private hasShippingTimesDescription(): boolean {
        return checkout.selectedShippingMethodTimes.description !== '';
    }
}
